import { ProductEditor } from '@/components/ProductEditor/ProductEditor';

/** Create product route — same workspace as edit; variant only affects empty-id redirect rules. */
export function CreateProduct() {
  return <ProductEditor variant="create" />;
}
